import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post, get } from '../../../helpers/api_helper';

// 1. Fetch Job Code
function* fetchOnboardingJobCodeSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_ONBOARDING_JOB_CODE, formData);

    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');
    yield put({ type: types.FETCH_ONBOARDING_JOB_CODE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_ONBOARDING_JOB_CODE_FAILURE, payload: error });
  }
}

// 2. Fetch Import List
function* fetchOnboardingImportListSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_ONBOARDING_IMPORT_LIST, formData);

    if (response.status !== 'success') {
      yield put({ type: types.FETCH_ONBOARDING_IMPORT_LIST_SUCCESS, payload: { data: [] } });
      return;
    }
    yield put({ type: types.FETCH_ONBOARDING_IMPORT_LIST_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_ONBOARDING_IMPORT_LIST_FAILURE, payload: error });
  }
}

// 3. Save Apply Job
function* saveOnboardingApplyJobSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_ONBOARDING_APPLY_JOB, payload);
    if (response.status !== 'success') throw new Error(response.message || 'Save failed');
    yield put({ type: types.SAVE_ONBOARDING_APPLY_JOB_SUCCESS });
    Swal.fire('Success', response.message || 'Saved successfully', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.SAVE_ONBOARDING_APPLY_JOB_FAILURE, payload: error });
  }
}

// 4. Fetch Import Template
function* fetchImportTemplateSaga({payload}) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_IMPORT_TEMPLATE,payload);
    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');
    yield put({ type: types.FETCH_IMPORT_TEMPLATE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.FETCH_IMPORT_TEMPLATE_FAILURE, payload: error });
  }
}

// 5. Upload File
function* uploadOnboardingImportFileSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_UPLOAD_ONBOARDING_IMPORT_FILE, payload);
    if (response.status !== 'success') throw new Error(response.message || 'Upload failed');
    yield put({ type: types.UPLOAD_ONBOARDING_IMPORT_FILE_SUCCESS });
    Swal.fire('Success', response.message || 'File uploaded successfully', 'success');
  } catch (error) {
    Swal.fire('Error', error.message, 'error');
    yield put({ type: types.UPLOAD_ONBOARDING_IMPORT_FILE_FAILURE, payload: error });
  }
}

function* fetchOnboardingJobApproveListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_ONBOARDING_JOB_APPROVE_LIST, action.payload);
    yield put({ type: types.FETCH_ONBOARDING_JOB_APPROVE_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_ONBOARDING_JOB_APPROVE_LIST_FAILURE, payload: error.message });
  }
}

function* saveOnboardingJobApproveSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_ONBOARDING_JOB_APPROVE, action.payload);
    yield put({ type: types.SAVE_ONBOARDING_JOB_APPROVE_SUCCESS });
    if (action.callback) action.callback(true, response.data);
  } catch (error) {
    yield put({ type: types.SAVE_ONBOARDING_JOB_APPROVE_FAILURE, payload: error.message });
    if (action.callback) action.callback(false, error);
  }
}

function* fetchDropdownListSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append('unit_id', payload.unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_ONBOARDING_DROPDOWN_LIST, formData);
    yield put({ type: types.FETCH_ONBOARDING_DROPDOWN_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_ONBOARDING_DROPDOWN_LIST_FAILURE, payload: error.message });
  }
}

function* fetchProcessListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_ONBOARDING_PROCESS_LIST, action.payload);
    yield put({ type: types.FETCH_ONBOARDING_PROCESS_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_ONBOARDING_PROCESS_LIST_FAILURE, payload: error.message });
  }
}

function* fetchAssignListSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_ONBOARDING_PROCESS_ASSIGN_LIST, action.payload);
    yield put({ type: types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST_FAILURE, payload: error.message });
  }
}

function* changeProcessStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_ONBOARDING_PROCESS_STATUS, action.payload);
    yield put({ type: types.CHANGE_ONBOARDING_PROCESS_STATUS_SUCCESS });
    Swal.fire(
      'Deleted!',
      response?.message || 'The assignment has been successfully removed.',
      'success'
    );
  } catch (error) {
    yield put({ type: types.CHANGE_ONBOARDING_PROCESS_STATUS_FAILURE, payload: error.message });
     Swal.fire(
      'Error!',
      error.message || 'Failed to remove the assignment.',
      'error'
    );
  }
}

function* saveOnboardingSchedulingSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_ONBOARDING_SCHEDULING_PROCESS, action.payload);
    yield put({ type: types.SAVE_ONBOARDING_SCHEDULING_PROCESS_SUCCESS });
    Swal.fire({
      title: 'Success!',
      text: response?.message || 'Onboarding schedule saved successfully.',
      icon: 'success',
      confirmButtonText: 'OK',
    });
    if (action.callback) action.callback(true, response.data);
  } catch (error) {
    yield put({ type: types.SAVE_ONBOARDING_SCHEDULING_PROCESS_FAILURE, payload: error.message });
    Swal.fire({
      title: 'Error!',
      text: error.message || 'Failed to save the onboarding schedule.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
    if (action.callback) action.callback(false, error);
  }
}

function* updateApplicantsLevelsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_UPDATE_APPLICANTSLEVELS, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Update failed');
    yield put({ type: types.UPDATE_APPLICANTS_LEVELS_SUCCESS });
    Swal.fire('Success', response.message || 'Updated successfully', 'success');
  } catch (error) {
    yield put({ type: types.UPDATE_APPLICANTS_LEVELS_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

function* fetchApplicantLevelDtlsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_APPLICANTSLEVELS_DETAILS, action.payload);
    if (response.status !== 'success') throw new Error(response.message || 'Fetch failed');
    yield put({ type: types.FETCH_APPLICANT_LEVEL_DTLS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_APPLICANT_LEVEL_DTLS_FAILURE, payload: error.message });
    Swal.fire('Error', error.message, 'error');
  }
}

// Main saga
export default function* onboardingSaga() {
  yield takeLatest(types.FETCH_ONBOARDING_JOB_CODE_REQUEST, fetchOnboardingJobCodeSaga);
  yield takeLatest(types.FETCH_ONBOARDING_IMPORT_LIST_REQUEST, fetchOnboardingImportListSaga);
  yield takeLatest(types.SAVE_ONBOARDING_APPLY_JOB_REQUEST, saveOnboardingApplyJobSaga);
  yield takeLatest(types.FETCH_IMPORT_TEMPLATE_REQUEST, fetchImportTemplateSaga);
  yield takeLatest(types.UPLOAD_ONBOARDING_IMPORT_FILE_REQUEST, uploadOnboardingImportFileSaga);
  yield takeLatest(types.FETCH_ONBOARDING_JOB_APPROVE_LIST, fetchOnboardingJobApproveListSaga);
  yield takeLatest(types.SAVE_ONBOARDING_JOB_APPROVE, saveOnboardingJobApproveSaga);

  yield takeLatest(types.FETCH_ONBOARDING_DROPDOWN_LIST, fetchDropdownListSaga);
  yield takeLatest(types.FETCH_ONBOARDING_PROCESS_LIST, fetchProcessListSaga);
  yield takeLatest(types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST, fetchAssignListSaga);
  yield takeLatest(types.CHANGE_ONBOARDING_PROCESS_STATUS, changeProcessStatusSaga);
  yield takeLatest(types.SAVE_ONBOARDING_SCHEDULING_PROCESS, saveOnboardingSchedulingSaga);
  yield takeLatest(types.UPDATE_APPLICANTS_LEVELS_REQUEST, updateApplicantsLevelsSaga);
  yield takeLatest(types.FETCH_APPLICANT_LEVEL_DTLS_REQUEST, fetchApplicantLevelDtlsSaga);
}
